import { InfiniteScroll } from "@nosto/preact"
import { wrapContent } from "./ContentWrapper"
import { useEffect } from "preact/hooks"

import VisualFilters from "./VisualFilters"
import Toolbar from "./Toolbar"
import Products from "./Products"
import Pagination from "./Pagination"
import Loader from "./elements/Loader"
import { SkeletonLoader } from "./Skeleton"
import NoResults from "./NoResults"

export function CategoryBody({ loading, foundProducts }) {
    useEffect(() => {
        // native element selectors to remove
        [ '[id$="__collection-filters"]' ].forEach(selector => {
            document.querySelectorAll(selector).forEach(el => el.remove())
        })
    }, [])

    return (foundProducts ? (
        <>
        <VisualFilters />
        <Toolbar />
        <Products />
        <Pagination />
        </>
    ) : loading ? (
        <SkeletonLoader />
    ) : (
        <NoResults />
    ))
}

export function CategoryBodyInfiniteScroll({ loading, foundProducts }) {
    if (!foundProducts) return loading ? <Loader /> : <NoResults />
    return (
        <>
            <Toolbar />
            <InfiniteScroll>
                <Products />
            </InfiniteScroll>
        </>
    )
}

// replace with following line to enable infinite scroll
// export default wrapContent("category", CategoryBodyInfiniteScroll)
export default wrapContent("category", CategoryBody)
